import React, { useState } from 'react';
import { Select, Space, Radio } from 'antd';
import { useSelector } from 'react-redux'
import { PaperDirection, PaperSize, getFlowTemplate, updateTemplate } from '@/store/flowsheet/flowsheet.slice'
import { useDispatch } from 'react-redux'
import { PapersizeOptions } from '@/components/FlowSheetEditor/constant'

const { Option } = Select;


export const SizeSelector = () => {
  const template = useSelector(getFlowTemplate)
  const dispatch = useDispatch()

  const handleSelect = (value: PaperSize) => {
    dispatch(updateTemplate({size: value}))
  };

  const onDirectionChange = (e) => {
    dispatch(updateTemplate({direction: e.target.value}))
  }

  return (
    <div style={{ width: 320, padding: 16, borderRadius: 8 }}>
      <Space>
        <div>Orientation:</div>
        <Radio.Group value={template?.direction} onChange={onDirectionChange}>
          <Radio value={PaperDirection.Landscape}>Landscape</Radio>
          <Radio value={PaperDirection.Portrait}>Portrait</Radio>
        </Radio.Group>

      </Space>
      <Select
        value={template?.size}
        style={{ width: '100%', marginTop: 16, marginBottom: 16 }}
        onChange={handleSelect}
      >
        {PapersizeOptions.map(opt => (
          <Option key={opt.value} value={opt.value}>{opt.label}</Option>
        ))}
      </Select>
    </div>
  );
};

function getSize(sizeName: string) {
  return PapersizeOptions.find(item => item.value === sizeName)
}